import { render, staticRenderFns } from "./NewsSingleMobile.vue?vue&type=template&id=34117b6a"
import script from "./NewsSingleMobile.vue?vue&type=script&lang=js"
export * from "./NewsSingleMobile.vue?vue&type=script&lang=js"
import style0 from "./NewsSingleMobile.vue?vue&type=style&index=0&id=34117b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports